module.exports = __webpack_public_path__ + "img/11s.5a8a77ea.png";